<template>
    <v-layout>
        <v-flex
            xs12
            pa-2
            class="group_Request__item-form">
            <v-form ref="form" v-model="fieldsValid">
                <v-text-field
                    id="group_name"
                    :counter="50"
                    :rules="nameRules"
                    v-model="groupRequest.groupName"
                    :disabled="isSubmitting"
                    :label="groupConstants.GROUP_NAME"
                    data-qe-id="group-configure_name_input"
                    autofocus
                    required>
                </v-text-field>
                <v-select
                    v-model="groupRequest.focusId"
                    :items="getGroupFocus"
                    item-text="name"
                    item-value="id"
                    :rules="[v => !!v || groupConstants.VALIDATIONS.ITEM_REQUIRED]"
                    :disabled="isSubmitting"
                    :label="groupConstants.FOCUS"
                    data-qe-id="group-configure_focus_dropdown"
                    v-on:change="getGroupSubFocus"
                    required>
                </v-select>
                <v-select
                    v-model="groupRequest.subFocusId"
                    :items="getGroupSubFocus"
                    item-text="name"
                    item-value="id"
                    :rules="[v => !!v || groupConstants.VALIDATIONS.ITEM_REQUIRED]"
                    :disabled="isSubmitting"
                    :label="groupConstants.SUB_FOCUS"
                    data-qe-id="group-configure_sub-focus_dropdown"
                    required>
                </v-select>
                <h6>
                    {{groupConstants.PRIVACY}}
                </h6>

                <v-radio-group
                    :disabled="isSubmitting"
                    v-model="groupRequest.groupSecurity"
                    :rules="[v => !!v || groupConstants.VALIDATIONS.ITEM_REQUIRED]"
                    required>
                    <v-radio :value="groupConstants.PUBLIC" data-qe-id="group-configure_type-public">
                        <div slot="label">
                            <p><em><i class="fas fa-lock-open"></i> {{groupConstants.PUBLIC}}</em> - <span class="groupRequestRadio">{{groupConstants.PUBLIC_GROUP}}</span></p>
                        </div>
                    </v-radio>
                    <v-radio :value="groupConstants.PRIVATE" data-qe-id="group-configure_type-private">
                        <div slot="label">
                            <p><em><i class="fas fa-lock"></i> {{groupConstants.PRIVATE}}</em> - <span class="groupRequestRadio">{{groupConstants.PRIVATE_GROUP}}</span></p>
                        </div>
                    </v-radio>
                    <v-radio :value="groupConstants.SECRET" data-qe-id="group-configure_type-secret">
                        <div slot="label">
                            <p><em><i class="fa fa-lock"></i> {{groupConstants.SECRET}}</em> - <span class="groupRequestRadio">{{groupConstants.SECRET_GROUP}}</span></p>
                        </div>
                    </v-radio>
                </v-radio-group>
                <div class="description">
                    <strong>{{groupConstants.DESCRIPTION}}</strong>
                    <v-textarea
                        v-model="groupRequest.groupDescription"
                        :name="groupConstants.DESCRIPTION"
                        data-qe-id="group-configure_description_input"
                        counter="256"
                        :disabled="isSubmitting"
                        :rules="[v => (!!v && v.length <= 256) || groupConstants.VALIDATIONS.DESCRIPTION_ERROR]">
                    </v-textarea>
                </div>

                <v-flex v-if="isSuperAdmin && isNewGroupRequest" class="group_requestor py-2">
                    <span>{{groupConstants.REQUESTOR_NAME}}</span>
                    <span>{{groupRequest.firstName}} {{groupRequest.lastName}}</span>
                </v-flex>

                <div class="button-group" v-if="isNewGroupRequest">
                    <v-btn
                        class="primary_btn transparent left"
                        :disabled="!isBackButtonDisabled || isSubmitting"
                        data-qe-id="group-configure_back_btn"
                        @click="backRequest">
                        {{groupConstants.BACK}}
                    </v-btn>
                    <v-btn
                        class="primary_btn transparent left"
                        :disabled="isSubmitting || !this.pendingRequestList || this.pendingRequestList.length <= 0 || isSkipButtonDisabled"
                        data-qe-id="group-configure_skip_btn"
                        @click="skipRequest">
                        {{groupConstants.SKIP}}
                    </v-btn>
                    <v-btn
                        class="primary_btn transparent"
                        :disabled="isSubmitting || !fieldsValid"
                        data-qe-id="group-configure_deny_btn"
                        @click="showDenial=true;showPopup=true">
                        {{groupConstants.DENY}}
                    </v-btn>
                    <v-btn
                        :disabled="!fieldsValid"
                        :loading="isSubmitting"
                        class="primary_btn"
                        data-qe-id="group-configure_approve_btn"
                        @click="reviewGroupRequest(true)">
                        {{groupConstants.APPROVE}}
                    </v-btn>
                </div>
                <v-layout
                    row
                    wrap
                    class="dailog-footer"
                    v-if="!isNewGroupRequest">
                    <v-flex xs12 sm12 md4>
                        <span v-if="!isNewGroupRequest" class="error-message">{{errorMessage}}</span>
                    </v-flex>
                    <v-flex xs12 sm12 md8 text-xs-right>
                        <div class="button-group1" v-if="!isNewGroupRequest">
                            <!-- if not pending request -->
                            <v-btn
                                class="primary_btn transparent"
                                :disabled="isSubmitting"
                                data-qe-id="group-configure_cancel_btn"
                                @click="resetForm">
                                {{groupConstants.CANCEL}}
                            </v-btn>
                            <v-btn
                                :loading="isSubmitting"
                                :disabled="!formValid || errorMessage.length > 0"
                                class="primary_btn"
                                data-qe-id="group-configure_save_btn"
                                @click="requestGroup">
                                {{ groupConstants.SAVE }}
                            </v-btn>
                        </div>
                    </v-flex>
                </v-layout>
            </v-form>
            <v-flex v-if="isNewGroupRequest">
                <span class="error-message">{{errorMessage}}</span>
            </v-flex>
        </v-flex>
        <v-dialog
            v-model="showPopup"
            content-class="small"
            persistent>
            <v-card v-if="showDenial" class="reason-denial">
                <v-flex><i class="far fa-times-circle right"
                           data-qe-id="close_dialog_btn"
                           @click="hidePopup"></i></v-flex>
                <v-form
                    class="pa-4"
                    ref="reasonForm"
                    v-model="validReason">
                    <div class="description">
                        <strong data-qe-id="group-configure_denial_reason_title">{{groupConstants.DENIAL_REASON}}</strong>
                        <v-textarea
                            v-model="groupRequest.rejectionReason"
                            counter="100"
                            data-qe-id="group-configure_denial_reason_input"
                            :disabled="isSubmitting"
                            :rules="[v => (v.length <= 100) || groupConstants.VALIDATIONS.REJECTION_REASON_ERROR]">
                        </v-textarea>
                    </div>
                    <div class="button-group text-xs-right">
                        <v-btn
                            class="primary_btn transparent"
                            :disabled="isSubmitting"
                            data-qe-id="cancel_dialog_btn"
                            @click="hidePopup">
                            {{groupConstants.CANCEL}}
                        </v-btn>
                        <v-btn
                            class="primary_btn"
                            :disabled="isSubmitting || !validReason"
                            :loading="isSubmitting"
                            data-qe-id="save_dialog_btn"
                            @click="reviewGroupRequest(false)">
                            {{groupConstants.CONFIRM_DENY}}
                        </v-btn>
                    </div>
                </v-form>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="showInfo"
            lazy
            absolute
            content-class="extra-small">
            <v-card class="showgroup-popup">
                <v-card-title>
                    <v-icon @click="hidePopup()" data-qe-id="close_dialog_btn">fas fa-times</v-icon>
                </v-card-title>
                <v-card-text v-html="alertMessage"></v-card-text>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    import { groupConstants } from '../GroupPage/groupConstant';
    import { mapActions, mapGetters, mapMutations } from "vuex";
    import { storeAction } from "../../store/storeActions.constant";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { storeMutation } from "../../store/storeMutations.constant";

    export default {
        name: 'GroupRequest',
        props: {
            isNewGroupRequest: {
                type: Boolean,
                default: false,
            },
        },
        created() {
            this.getFocusList();
            if (this.isNewGroupRequest) {
                this.getPendingRequestList();
            } else {
                this.getGroupConfiguration();
            }
        },
        data() {
            return {
                requestNumber: 0,
                groupConstants,
                messageType: '',
                showPopup: false,
                showDenial: false,
                alertMessage: '',
                isSubmitting: false,
                fieldsValid: false,
                validReason: false,
                showInfo: false,
                alreadyExistingNames: [],
                submitError: '',
                nameRules: [
                    v => !!v || groupConstants.VALIDATIONS.NAME_REQUIRED,
                    v => (!!v && v.length <= 50) || groupConstants.VALIDATIONS.NAME_LENGTH_VALIDATION,
                ],
            };
        },
        methods: {
            ...mapActions({
                getFocusList: `group/${storeAction.getFocusList}`,
                getGroupConfiguration: `group/${storeAction.getGroupConfiguration}`,
                requestGroupPost: `group/${storeAction.requestGroupPost}`,
                reviewRequest: `group/${storeAction.reviewRequest}`,
                getPendingRequestList: `group/${storeAction.getPendingRequestList}`,
            }),
            ...mapMutations({
                setUserCommunityInfo: `chapter/${storeMutation.setUserCommunityInfo}`,
            }),
            skipRequest() {
                if (this.pendingRequestList.length > this.requestNumber) {
                    this.requestNumber += 1;
                } else {
                    this.requestNumber = 0;
                }
            },
            backRequest() {
                if (this.pendingRequestList.length > this.requestNumber) {
                    this.requestNumber -= 1;
                    for (let i = this.requestNumber; i >= 0; i -= 1) {
                        if (this.pendingRequestList[this.requestNumber].approvalStatus === 'A') {
                            this.requestNumber -= 1;
                        }
                    }
                } else {
                    this.requestNumber = 0;
                }
            },
            reviewGroupRequest(isApproved) {
                if (this.groupRequest && this.$refs.form.validate()) {
                    this.isSubmitting = true;
                    this.groupRequest.approvalStatus = isApproved ? "A" : "R";
                    this.reviewRequest(JSON.parse(JSON.stringify(this.groupRequest))).then(() => {
                        this.isSubmitting = false;
                        this.messageType = 'success';
                        this.alertMessage = isApproved ? this.groupConstants.VALIDATIONS.APPROVE_SUCCESS : this.groupConstants.VALIDATIONS.REJECT_SUCCESS;
                        this.showInfo = true;
                        //this.skipRequest();
                    }).catch((error) => {
                        this.isSubmitting = false;
                        if (error.response.data.message.toLowerCase().includes(this.groupConstants.VALIDATIONS.ALREADY_EXSIST)) {
                            this.alreadyExistingNames.push(this.groupRequest.groupName.toLowerCase());
                        } else {
                            this.submitError = error.response.data.message;
                            setTimeout(() => {
                                this.submitError = '';
                            }, 3000);
                        }
                    });
                }
            },
            requestGroup() {
                if (this.$refs.form.validate()) {
                    this.isSubmitting = true;
                    this.requestGroupPost({
                        groupObject: JSON.parse(JSON.stringify(this.groupRequest)),
                        isNewRequestGroup: false,
                    }).then(() => {
                        this.isSubmitting = false;
                        this.messageType = 'success';
                        this.alertMessage = this.groupConstants.VALIDATIONS.UPDATE_SUCCESS;
                        this.showInfo = true;
                        this.setUserCommunityInfo({
                            ...this.communityInfo,
                            category: this.groupRequest.groupSecurity,
                            name: this.groupRequest.groupName,
                        });
                        const community = this.usersCommunitiesList.find(item => item.communityId === this.$route.params.communityId);
                        community.name = this.groupRequest.groupName;
                        community.category = this.groupRequest.groupSecurity;
                    }).catch((error) => {
                        //TODO Error Handling
                        this.isSubmitting = false;
                        if (error.response.data.message.toLowerCase().includes(this.groupConstants.VALIDATIONS.ALREADY_EXSIST)) {
                            this.alreadyExistingNames.push(this.groupRequest.groupName.toLowerCase());
                        } else {
                            this.submitError = error.response.data.message;
                            setTimeout(() => {
                                this.submitError = '';
                            }, 3000);
                        }
                    });
                }
            },
            resetForm() {
                if (this.$refs.form) {
                    this.$refs.form.reset();
                } else {
                    Object.keys(this.groupRequest).forEach((k) => { this.groupRequest[k] = null; });
                }
                setTimeout(() => {
                    this.groupRequest.groupSecurity = this.groupConstants.PUBLIC;
                }, 0);
            },
            hidePopup() {
                if (this.showDenial) {
                    this.$refs.reasonForm.reset();
                }
                this.showPopup = false;
                this.showDenial = false;
                this.showInfo = false;
                this.messageType = '';
                this.alertMessage = '';
                this.groupRequest.rejectionReason = '';
                this.$emit("close");
            },

        },
        computed: {
            ...mapGetters({
                groupConfigRequest: `group/${storeGetters.groupConfigRequest}`,
                pendingRequestList: `group/${storeGetters.pendingRequestList}`,
                groupFocusList: `group/${storeGetters.groupFocusList}`,
                isAdmin: `chapter/${storeGetters.getIsCommunityAdmin}`,
                groupIdPromise: `${storeGetters.communityIdPromise}`,
                userPermissionsData: `auth/${storeGetters.permissionsData}`,
                usersCommunitiesList: `chapter/${storeGetters.usersCommunitiesList}`,
                communityInfo: `chapter/${storeGetters.communityInfo}`,
            }),
            errorMessage() {
                return (this.groupRequest.groupName && this.alreadyExistingNames.includes(this.groupRequest.groupName.toLowerCase())) ? this.groupConstants.VALIDATIONS.GROUPNAME_ALREADY_EXISTS : this.submitError;
            },
            isSuperAdmin() {
                return this.communityInfo && this.communityInfo.roles && this.communityInfo.roles.some(o => o === "Group Super Administrator");
            },
            groupRequestorName() {
                return 'First Name Last Name';
            },
            groupRequest() {
                let groupRequestObj = {
                    groupSecurity: groupConstants.PUBLIC,
                };
                if (this.isNewGroupRequest) {
                    groupRequestObj = this.pendingRequestList && this.pendingRequestList.length > 0 ? this.pendingRequestList[this.requestNumber] : {};
                } else if (this.$route.params.communityId) {
                    groupRequestObj = this.groupConfigRequest;
                }
                return groupRequestObj;
            },
            getGroupFocus() {
                if (this.groupFocusList) {
                    return this.groupFocusList.filter(v => v.parentId == null);
                }
            },

            getGroupSubFocus() {
                if (this.groupFocusList && this.groupRequest) {
                    return this.groupFocusList.filter(v => v.parentId === this.groupRequest.focusId);
                }
            },

            formValid() {
                return this.fieldsValid && (
                    this.groupRequest.groupName &&
                    this.groupRequest.groupDescription
                );
            },
            isBackButtonDisabled() {
                return this.requestNumber > 0;
            },
             isSkipButtonDisabled() {
                return this.requestNumber === this.pendingRequestList.length - 1;
            },
        },
    };
</script>

<style lang="scss">
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .TAndCLink {
        text-decoration: none;
        font-weight: bold;
    }

    .showgroup-popup {
        .v-card__title {
            background: $ypo-blue;
            position: relative;
            padding: 20px;

            .v-icon {
                position: absolute;
                color: $white;
                font-size: 16px;
                right: 5px;
                cursor: pointer;
                top: 8px;
            }
        }

        .v-card__text {
            padding: 40px 10px;
            text-align: center;
            font-weight: 600;
        }
    }

    .infoPopup {
        &__popup {
            position: relative;
            font-size: 18px;
            font-weight: bold;
            padding: 40px 200px 40px 200px;
            font-family: Raleway;
        }

        i {
            cursor: pointer;
            position: absolute;
            right: 15px;
            top: 15px;
        }

        &__error {
            color: red;
        }

        &__success {
            color: #083050;
        }
    }

    .rejected-successfully {
        text-align: center;
        padding: 30px 150px;

        i.fa-times-circle {
            font-size: 12px;
            color: $ypo-cta;
            position: absolute;
            right: 5px;
            top: 5px;
            cursor: pointer;
        }
    }

    .reason-denial {
        i.fa-times-circle {
            font-size: 18px;
            color: $ypo-cta;
            position: relative;
            top: 5px;
            right: 5px;
            cursor: pointer;
        }

        strong {
            color: $ypo-blue;

        }

        .v-textarea {
            textarea {
                border: 1px $ypo-medium-gray solid;
                border-radius: 3px;
                padding: 10px;
            }

        }

        .v-text-field>.v-input__control>.v-input__slot:before {
            border: 0;
        }
    }

    .dailog-footer {
        border-top: 1px solid $ypo-medium-gray;
        padding-top: 10px;
        margin-top: 10px;

        .error-message {
            display: block;
            margin-top: 11px;
            white-space: nowrap;
            @include breakpoint(xs) {
                white-space: inherit !important;
            }
        }

    }
    .button-group {
        @include breakpoint(xs) {
            .primary_btn {
               padding: 8px 15px;
           }
            }
    } 
</style>
